module.exports = __webpack_public_path__ + "img/symbol_3.68eb40f7.png";